import React from "react";
import { createRoot } from "react-dom/client";
import MultiUnitTracker from "./app/MultiUnitTracker.jsx";

const root = document.getElementById("root");

try {
  createRoot(root).render(
    <React.StrictMode>
      <MultiUnitTracker />
    </React.StrictMode>
  );
} catch (error) {
  console.error(error);
  root.innerHTML =
    '<div style="padding:24px;color:#f87171;font-family:monospace">PT Tracker failed to start. Open the browser console for details.</div>';
}
